import { Component } from 'react';
import AdminUtils from '../../admin-utils';
import AssetPickerEditOption from './asset-picker-edit-option';

class AssetPickerRenameFolderOption extends Component {
  render() {
    return (
      <div className="asset-picker-edit-option">
        <AssetPickerEditOption
          title="Edit the name of this folder"
          src="/images/new_ui_edit_icon.svg"
          height="75%"
          onClick={this.handleEditNameClick}
        />
      </div>
    );
  }

  handleEditNameClick = (e) => {
    e.preventDefault();
    AdminUtils.promptForNewName(this.props.folder, this.props.updateCallback);
  };
}

export default AssetPickerRenameFolderOption;
